import script from "./AIChatbot.vue?vue&type=script&setup=true&lang=js"
export * from "./AIChatbot.vue?vue&type=script&setup=true&lang=js"

import "./AIChatbot.vue?vue&type=style&index=0&id=410a2c7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-410a2c7a"]])

export default __exports__